import { forwardRef, useImperativeHandle, useState } from "react";
import { Modal } from "react-bootstrap";
import { ConsultaPadrao } from "../../../../../components/ConsultaPadrao";
import { model_categoria_exercicio } from "../../../../../models";

export const CategoriaExercicio = forwardRef((props: any, ref) => {
    const [show, setShow] = useState(false);
    const [categoria, setCategoria] = useState<any>();

    function openModal(_categoria: any) {
        setCategoria(_categoria);
        setShow(true);
    }

    function closeModal() {
        setShow(false);
    }

    useImperativeHandle(ref, () => ({
        openModal
    }))

    const columns = [
        { field: 'exercicio.exercdescricao', header: 'Exercício' },
        { field: 'functions', style: { minWidth: '3rem', width: '3rem' } }
    ];

    return (
        categoria &&
        <Modal show={show} onHide={closeModal} centered={true} size='xl'>
            <ConsultaPadrao
                disableEdit
                model={{
                    ...model_categoria_exercicio,
                    api_get: '/categoria/exercicios?catid=' + categoria?.catid,
                    inputs: model_categoria_exercicio.inputs.map(input =>
                        input.id === 'categoria.catid' ? { ...input, defaultValue: categoria?.catid } : input
                    )
                }}
                columns={columns}
                scrollHeight='500px'
            />
        </Modal>
    )
})